export enum PromptOverviewTab {
  Content = "content",
  Analytics = "analytics",
}

export const PROMPT_OVERVIEW_TAB_PARAM = "promptOverviewTab";

export const getPromptOverviewTabIndex = (selectedTab: PromptOverviewTab): number =>
  selectedTab === PromptOverviewTab.Analytics ? 1 : 0;
